import React from "react";

import {
  DATE_RANGE_OPTIONS,
  UPLOAD_STATUS_FILTER_OPTIONS,
} from "constants/constants";
import { SearchBar } from "widgets";

import {
  UPLOAD_HISTORY_COPY,
  UPLOAD_HISTORY_FIELD_LABELS,
  UPLOAD_HISTORY_SEARCHABLE_FIELDS,
} from "../../constants/uploadsContent";
import styles from "./FileUploadsHistory.module.scss";

const UploadHistoryToolbar = ({
  searchTerm,
  statusFilter,
  dateRange,
  onSearchChange,
  onStatusFilterChange,
  onDateRangeChange,
}) => (
  <div className={styles.toolbar}>
    <h2 className={styles.title}>{UPLOAD_HISTORY_COPY.TITLE}</h2>

    <div className={styles.filters}>
      <SearchBar
        value={searchTerm}
        onChange={onSearchChange}
        searchableFields={UPLOAD_HISTORY_SEARCHABLE_FIELDS}
        fieldLabels={UPLOAD_HISTORY_FIELD_LABELS}
        className={styles.searchInput}
      />

      <select
        className={styles.filterSelect}
        value={statusFilter}
        onChange={(event) => onStatusFilterChange(event.target.value)}
      >
        {UPLOAD_STATUS_FILTER_OPTIONS.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>

      <select
        className={styles.filterSelect}
        value={dateRange}
        onChange={(event) => onDateRangeChange(event.target.value)}
      >
        {DATE_RANGE_OPTIONS.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default UploadHistoryToolbar;
